import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import constants from '../../../../constants';

import { Select, message } from 'antd';
import { MarkerStarIcon, LegendGenericIcon, LegendParkingLotIcon, LegendGarageIcon, AreaIcon } from '../../../icons';
import AirAutocomplete from '../../AirAutocomplete';
import HereService from '../../../../services/Here';
import { InfoCircleIcon } from '../../../../common/icons';
import AirButton from '../../AirButton';
import AirModalTitlebar from '../../AirModalTitlebar';
import MapAddressRadius from '../../../../common/components/MapMenu/MapAddressRadius';

import './LocationAutocomplete.css';

const { Option } = Select;

const API_KEY = constants.HERE_API_KEY;

const helperPOIIcon = (scenario, type) => {
  switch (scenario) {
    case 'switch':
      switch (type) {
        case 'garage':
          return <LegendGarageIcon style={{ width: '20px', height: '20px' }} />;
        case 'parking':
          return <LegendParkingLotIcon style={{ width: '15px', height: '20px' }} />;
        default:
          return <LegendGenericIcon style={{ width: '20px', height: '19px' }} />;
      }
    case 'listItem':
      switch (type) {
        case 'garage':
          return <LegendGarageIcon style={{ width: '13px', height: '13px' }} />;
        case 'parking':
          return <LegendParkingLotIcon style={{ width: '9px', height: '12px' }} />;
        default:
          return <LegendGenericIcon style={{ width: '13px', height: '12px' }} />;
      }
    // No Default
    default:
      return <Fragment />;
  }
};

function renderOption(item) {
  switch (item.source) {
    case 'poi':
      return (
        <AirAutocomplete.Option key={item.key} value={JSON.stringify(item)} text={item.title || item.address} className="AutocompleteOption AutocompleteThemePOI">
          <div className="AutocompleteOptionIcon">{helperPOIIcon('listItem', item.type)}</div>
          <div className="AutocompleteOptionDescription">
            {!item.label ? (
              <div>{item.address}</div>
            ) : (
              <Fragment>
                <div>{item.label}</div>
                <div>{item.address}</div>
              </Fragment>
            )}
          </div>
        </AirAutocomplete.Option>
      );
    case 'places':
      return (
        <AirAutocomplete.Option key={item.key} value={JSON.stringify(item)} text={item.title || item.address} className="AutocompleteOption AutocompleteThemePlaces">
          <div className="AutocompleteOptionIcon">
            <AreaIcon width={12} height={12} />
          </div>
          <div className="AutocompleteOptionDescription">
            {!item.label ? (
              <div dangerouslySetInnerHTML={{ __html: item.address }} />
            ) : (
              <Fragment>
                <div dangerouslySetInnerHTML={{ __html: item.label }} />
                <div dangerouslySetInnerHTML={{ __html: item.address }} />
              </Fragment>
            )}
          </div>
        </AirAutocomplete.Option>
      );
    default:
      return (
        <AirAutocomplete.Option key={item.locationId} text={item.label.replace(/(<b>|<\/b>)/gm, '')}>
          <div dangerouslySetInnerHTML={{ __html: item.label }} />
        </AirAutocomplete.Option>
      );
  }
}

@inject('scriptsLoaderStore', 'translationsStore', 'poiStore', 'mapStore')
@observer
export default class LocationAutocomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataSource: [],
      visiblePOIPick: false,
      selectedPOIType: '',
      infoPOIVisibleModal: false,
      infoPOIData: {},
      shapeLevel: 'default'
    };

    this.mapservice = new HereService(API_KEY);
  }

  onShapeLevelChange = value => {
    this.setState({ shapeLevel: value });
  }

  handleSearch = what => {
    if (what === '') {
      return;
    }
    const places = this.mapservice.places(what, `${this.props.center.lat},${this.props.center.lng}`);

    const { poiStore } = this.props;
    Promise.all([this.mapservice.autocomplete(what), poiStore.search(what), places]).then(([{ suggestions }, poiData, placesResponse]) => {
      const placesProcessed = placesResponse.map(placeResponse => ({
        source: 'places',
        label: placeResponse.highlightedTitle,
        key: `places:${placeResponse.id}`,
        lat: placeResponse.position[0],
        lng: placeResponse.position[1],
        radius: 200,
        type: placeResponse.category,
        address: ((placeResponse || {}).vicinity || '').replace(/<br\/>/gi, ' ')
      }));

      suggestions = (suggestions || [])
        .map(suggestion => ({ source: 'mapservice', ...suggestion }))
        .concat(
          (poiData || []).map((poi, index) => ({
            source: 'poi',
            key: `poi:${index}`,
            lat: poi.position.coordinates[1],
            lng: poi.position.coordinates[0],
            radius: poi.radius,
            label: poi.title,
            address: poi.address,
            type: poi.type
          }))
        )
        .concat(placesProcessed);

      this.setState({ dataSource: suggestions || [] });
    });
    if (what === '') {
      this.props.onCancelSearch();
    }
  };

  handleSelect = value => {
    let metaValue = false;
    let lang = 'IT';
    let shapeLevel = this.state.shapeLevel;
    try {
      metaValue = JSON.parse(value);
    } catch (e) {}
    if (metaValue !== false || value instanceof Object) {
      const { source, lat, lng, radius, type, label } = metaValue || value;
      this.togglePOIPicker({ hide: true });
      // this.props.onSelect({lat, lng, mapView: {radius}, label, matchLevel: `${source}.${type}`, metaData: metaValue});
      if (this.props.isGeofenceLocation) {
        this.props.onGeofenceSelect({lat, lng, mapView: {radius}, label, matchLevel: `${source}.${type}`, metaData: metaValue});
      } else {
        this.props.onSelect({lat, lng, mapView: {radius}, label, matchLevel: `${source}.${type}`, metaData: metaValue});
      }
    } else {
      // const usingApiKey = this.props.mapStore.usingApiKey;
      /*
      this.mapservice.lookupbyid(value, lang, shapeLevel).then((lookupResponse) => {
        if (lookupResponse.hasOwnProperty('position') && lookupResponse.position.hasOwnProperty('lat') && lookupResponse.position.hasOwnProperty('lng') && lookupResponse.position.lat !== 0 && lookupResponse.position.lng !== 0 ) {
          const { resultType: matchLevel, position: { lat, lng } } = lookupResponse;
          const { address: { label } } = lookupResponse;
          const { mapView: { west, south, east, north } } = lookupResponse;

          const bottomLeftPoint = new window.H.geo.Point(south, west);
          const topLeftPoint = new window.H.geo.Point(north, west);
          const bottomRightPoint = new window.H.geo.Point(south, east);
          const width = Math.round(bottomLeftPoint.distance(bottomRightPoint));
          const height = Math.round(bottomLeftPoint.distance(topLeftPoint));
          if (this.props.isGeofenceLocation) {
            if (usingApiKey) {
              this.props.onGeofenceSelect({
                lat,
                lng,
                label,
                mapView: { radius: Math.min(height, width), height, width },
                // shape: Response.View[0].Result[0].Location.Shape.Value,  // INFO GS7 used from review wont have
                shape: '',
                matchLevel,
                shapeLevel: shapeLevel
              });
            } else {
              if (Response.View[0].Result[0].Location.Shape) {
                this.props.onGeofenceSelect({
                  lat,
                  lng,
                  label,
                  mapView: { radius: Math.min(height, width), height, width },
                  shape: Response.View[0].Result[0].Location.Shape.Value,
                  matchLevel,
                  shapeLevel: shapeLevel
                });
              } else {
                message.error(this.props.translationsStore.translate('shapeLevelMissing'));
              }
            }
          } else {
            this.props.onSelect({
              lat,
              lng,
              label,
              mapView: { radius: Math.min(height, width), height, width },
              matchLevel
            });
          }
        } else {
          this.props.onSelect({
            lat: 0,
            lng: 0,
            label: '',
            mapView: { radius: 3000000 },
            matchLevel: 'world'
          });
        }
      });
      */

      this.mapservice.geocode(value, lang, shapeLevel).then((data) => {
        if (data.items && data.items[0]) {
          const item = data.items[0];

          const { lat, lng } = item.position;
          const label = item.address.label || '';
          const matchLevel = item.resultType || '';
          const { north, south, east, west } = item.mapView;

          const bottomLeftPoint = new window.H.geo.Point(south, west);
          const topLeftPoint = new window.H.geo.Point(north, west);
          const bottomRightPoint = new window.H.geo.Point(south, east);

          const width = Math.round(bottomLeftPoint.distance(bottomRightPoint));
          const height = Math.round(bottomLeftPoint.distance(topLeftPoint));

          if (this.props.isGeofenceLocation) {
            if (item.shape) {
              this.props.onGeofenceSelect({
                lat,
                lng,
                label,
                mapView: { radius: Math.min(height, width), height, width },
                shape: item.shape,
                matchLevel,
                shapeLevel
              });
            } else {
              message.error(this.props.translationsStore.translate('shapeLevelMissing'));
            }
          } else {
            this.props.onSelect({
              lat,
              lng,
              label,
              mapView: { radius: Math.min(height, width), height, width },
              matchLevel
            });
          }
        } else {
          this.props.onSelect({
            lat: 0,
            lng: 0,
            label: '',
            mapView: { radius: 3000000 },
            matchLevel: 'world'
          });
        }
      });
    }
  };

  togglePOISwitchType = newType => {
    this.setState({ selectedPOIType: this.state.selectedPOIType === newType ? '' : newType });
  };

  togglePOIPicker = (forceShowOrHide = {}) => {
    const { show, hide } = forceShowOrHide;
    const visiblePOIPick = show === true ? true : hide === true ? false : !this.state.visiblePOIPick;
    this.setState({ visiblePOIPick });
  };

  onPOIPick = poi => {
    const {
      position: { coordinates },
      radius,
      type,
      title,
      address
    } = poi;
    this.handleSelect({
      lat: coordinates[1],
      lng: coordinates[0],
      radius,
      type,
      label: title || address
    });
  };

  showPOIInfo = poiData => {
    this.handleShowInfoPOI(poiData);
  };

  deletePOI = () => {
    const { poiStore } = this.props;
    const { infoPOIData } = this.state;
    poiStore.delete(infoPOIData).then(response => {
      const { success } = response;
      if (success) {
        this.handleHideInfoPOI();
      } else {
        console.log(response);
      }
    });
  };

  handleShowInfoPOI = poiData => {
    this.setState({ infoPOIVisibleModal: true, infoPOIData: poiData });
  };

  handleHideInfoPOI = () => {
    this.setState({ infoPOIVisibleModal: false, infoPOIData: {} });
  };

  render() {
    const {
      translationsStore,
      poiStore: { poilist }
    } = this.props;
    const { dataSource, visiblePOIPick, infoPOIData } = this.state;

    const activePOIList = (poilist || []).length > 0;
    const poiListSelected = (poilist || []).filter(poi => this.state.selectedPOIType === '' || this.state.selectedPOIType === poi.type);
    const poiSwitchableTypes = [
      {
        key: 'garage',
        label: translationsStore.translate('poiTypes.plural.garage'),
        length: (poilist || []).filter(poi => poi.type === 'garage').length
      },
      {
        key: 'parking',
        label: translationsStore.translate('poiTypes.plural.parking'),
        length: (poilist || []).filter(poi => poi.type === 'parking').length
      },
      {
        key: 'generic',
        label: translationsStore.translate('poiTypes.plural.generic'),
        length: (poilist || []).filter(poi => poi.type === 'generic').length
      }
    ];

    const showExtraIcons = (typeof this.props.showExtraIcons !== "undefined") ? this.props.showExtraIcons : true;

    const showShapeLevelIcons = (typeof this.props.showShapeLevelIcons !== "undefined") ? this.props.showShapeLevelIcons : false;

    const { radius = 0, position } = infoPOIData;
    const {
      coordinates: [lng, lat]
    } = position || { coordinates: [] };

    return (
      <Fragment>
        {showShapeLevelIcons && (
          <Fragment>
            <div className="IncludeShapeLevelPane">
              <Select defaultValue="default" style={{ width: 150, padding: '5px' }} onChange={this.onShapeLevelChange}>
                <Option value="default">{translationsStore.translate('shapeLevels.default')}</Option>
                <Option value="country">{translationsStore.translate('shapeLevels.country')}</Option>
                <Option value="state">{translationsStore.translate('shapeLevels.state')}</Option>
                <Option value="county">{translationsStore.translate('shapeLevels.county')}</Option>
                <Option value="city">{translationsStore.translate('shapeLevels.city')}</Option>
                <Option value="district">{translationsStore.translate('shapeLevels.district')}</Option>
                <Option value="postalCode">{translationsStore.translate('shapeLevels.postalCode')}</Option>
              </Select>
            </div>
          </Fragment>
        )}
        <AirAutocomplete
          dataSource={dataSource.map(renderOption)}
          className={`LocationAutocomplete${showExtraIcons ? ' WithExtraIcons' : ''}`}
          placeholder={translationsStore.translate('filtersOnMap.search.placeholder')}
          onSearch={this.handleSearch}
          onSelect={this.handleSelect}
          optionLabelProp="text"
          allowClear
        />
        {showExtraIcons && (
          <Fragment>
            <div className="ExtraPane">
              <div className="ExtraPaneTray">
                <div className={`POIPick${activePOIList ? ' active' : ''}`} onClick={this.togglePOIPicker}>
                  <MarkerStarIcon style={{ width: '15px', height: '22px' }} />
                </div>
              </div>
            </div>
            {visiblePOIPick && (
              <div className="ExtraContainer">
                <div className="POIListIntro">
                  <div className="POIListIntroHeader">
                    <div>{translationsStore.translate('poiPick.listIntro.title')}</div>
                  </div>
                  <div className="POIListIntroSwitches">
                    {poiSwitchableTypes.map((type, index) => (
                      <div
                        key={index}
                        className={`POIListIntroSwitch${type.length > 0 ? ' active' : ''}${this.state.selectedPOIType === type.key ? ' selected' : ''}`}
                        onClick={() => this.togglePOISwitchType(type.key)}
                      >
                        <div>{helperPOIIcon('switch', type.key)}</div>
                        <div>{type.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="POIListWrapper">
                  {poiListSelected.length > 0 ? (
                    <Fragment>
                      <div className="POIListContainer">
                        <div className="POIList">
                          {poiListSelected.map((item, index) => (
                            <div key={index} className="POIListItem" onClick={() => this.onPOIPick(item)}>
                              <div className="POIListItemIcon">{helperPOIIcon('listItem', item.type)}</div>
                              <div className="POIListItemDescription">
                                {!item.title ? (
                                  <div>{item.address}</div>
                                ) : (
                                  <Fragment>
                                    <div>{item.title}</div>
                                    <div>{item.address}</div>
                                  </Fragment>
                                )}
                              </div>
                              <div className="POIListItemAction">
                                <InfoCircleIcon
                                  onClick={e => {
                                    e.stopPropagation();
                                    this.showPOIInfo(item);
                                  }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <AirModalTitlebar
                        className="InfoPOIModal"
                        visible={this.state.infoPOIVisibleModal}
                        cancelButton={<AirButton size="large" label={translationsStore.translate('infoPOIModal.labelClose')} style={{ width: 240 }} />}
                        okButton={<AirButton size="large" light label={translationsStore.translate('infoPOIModal.labelDelete')} style={{ marginLeft: 20, width: 240 }} />}
                        onCancel={this.handleHideInfoPOI}
                        onOk={this.deletePOI}
                        title={translationsStore.translate('infoPOIModal.title')}
                        titlebarStyle={{ color: 'white', backgroundColor: 'var(--yellow)' }}
                        buttonsStyle={{ justifyContent: 'center' }}
                        width={560}
                      >
                        {!!lng && !!lat && !!radius && <MapAddressRadius lat={lat} lng={lng} radius={radius} />}
                        <div className="infoPOI">
                          <div className="POISavedMessage">{translationsStore.translate('infoPOIModal.POISaved.message')}</div>
                          <div className="POICell">
                            <div className="POICellLabel">{translationsStore.translate('infoPOIModal.POISaved.labelTitle')}</div>
                            <div className="POICellValue">{this.state.infoPOIData.title}</div>
                          </div>
                          <div className="POICell">
                            <div className="POICellLabel">{translationsStore.translate('infoPOIModal.POISaved.labelType')}</div>
                            <div className="POICellValue">{translationsStore.translate(`poiTypes.base.${this.state.infoPOIData.type}`)}</div>
                          </div>
                        </div>
                      </AirModalTitlebar>
                    </Fragment>
                  ) : (
                    <div className="POIListNoItems">{translationsStore.translate('poiPick.listNoItemsHelp')}</div>
                  )}
                </div>
              </div>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Map/LocationAutocomplete/LocationAutocomplete.js